import React, { useState } from 'react';
import ReactDOM from 'react-dom';

const defaultProvider = 'AWS';

const displayDatacell = (datacell) =>
  datacell.includes('US') ? 'US' : datacell;

const RegionInput = ({ regions, reuse }) => {
  const [selectedProvider, setSelectedProvider] = useState(defaultProvider);
  const knownProviders = Object.keys(regions);
  const knownDatacells = regions[selectedProvider];

  return (
    <React.Fragment>
      <fieldset className='field' style={reuse ? {} : { display: 'none' }}>
        <label>
          Cloud Provider
          <select
            className='lg'
            name='cloud_provider'
            defaultValue={defaultProvider}
            onChange={(e) => setSelectedProvider(e.target.value)}
          >
            {knownProviders.map((provider) => (
              <option key={provider} value={provider}>
                {provider}
              </option>
            ))}
          </select>
        </label>
      </fieldset>

      <fieldset className='field'>
        <label>
          {reuse ? 'Datacell' : 'Where should we host your logs?'}
          <select key={selectedProvider} className='lg' name='datacell'>
            {knownDatacells.map((datacell) => (
              <option key={datacell} value={datacell}>
                {displayDatacell(datacell)}
              </option>
            ))}
          </select>
        </label>
        <span class="tip">
          Note: The legacy <a href="http://help.papertrailapp.com/kb/how-it-works/http-api">HTTP API</a> is only available with US hosting.
        </span>
      </fieldset>
    </React.Fragment>
  );
};

ReactDOM.render(
  <RegionInput regions={PT.swo_regions} reuse={PT.swo_reuse} />,
  document.getElementById('swo-region-ui')
);
